import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useLayoutEffect } from 'react';

var DEFAULT_OFFSET = 0;
var DEBOUNCE = 50;
var useStickyHeader = function useStickyHeader() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      offset: DEFAULT_OFFSET
    },
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? DEFAULT_OFFSET : _ref$offset;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    sticky = _useState2[0],
    setSticky = _useState2[1];
  useLayoutEffect(function () {
    var debounce;
    var handler = function handler() {
      debounce = window.setTimeout(function () {
        var isStocky = window.scrollY > offset;
        if (isStocky === sticky) {
          return;
        }
        setSticky(window.scrollY > offset);
      }, DEBOUNCE);
    };
    window.addEventListener('resize', handler);
    window.addEventListener('scroll', handler);
    return function () {
      window.removeEventListener('resize', handler);
      window.removeEventListener('scroll', handler);
      window.clearTimeout(debounce);
    };
  });
  return sticky;
};

export { useStickyHeader as default };
